import axios from "axios";
import { cleanObject } from "helper/cleanObject";

const path = "/swaps/";

export const swapService = {
    async list(filter = {}) {
        let searchParams = new URLSearchParams(cleanObject(filter));
        return await axios.get(path + "admin" + "?" + searchParams.toString());
    },

    async view(id) {
        return await axios.get(path + `{id}?id=${id}`);
    },

    async remove(id) {
        return await axios.delete(path + `delete/${id}`);
    },
};
